(function(globals){

    var capitalise = function() {
        var string = this;
        return string[0].toUpperCase() + string.substr(1);
    };

    if (Object.defineProperty) {
        try {
            Object.defineProperty(String.prototype, 'capitalise', {
                value: capitalise, configurable: true, enumerable: false, writable: true
            });
        } catch(e) {}
    }

})(this);


// WEBPACK FOOTER //
// ./app/utils/string.prototype.capitalise.js